<div class="offcanvas-md offcanvas-end bg-body-tertiary" tabindex="-1" id="sidebarMenu">
    <div class="offcanvas-header">
        <h5 class="offcanvas-title" id="sidebarMenuLabel">SigeCond</h5>
        <button type="button" class="btn-close" data-bs-dismiss="offcanvas" data-bs-target="#sidebarMenu"></button>
    </div>
    <div class="offcanvas-body d-md-flex flex-column p-0 overflow-y-auto">
        <ul class="nav flex-column mt-md-3">
            @for (item of menu; track $index) {
                @if (item.subtitle) {
                    <h6 class="fs-8 fw-bold px-3 mt-4 mb-2 text-body-tertiary text-uppercase" [accessControl]="item.accessControl">
                        {{ item.subtitle }} 
                    </h6>
                } @else {
                    <li class="nav-item" data-bs-dismiss="offcanvas" data-bs-target="#sidebarMenu" [accessControl]="item.accessControl">
                        <a class="nav-link d-flex align-items-center gap-2 active" [routerLink]="[item.route]" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }">
                            <i class="bi bi-{{ item.icon }}"></i> {{ item.name }}
                        </a>
                    </li>
                }
            }
        </ul>
        <hr class="my-3 d-md-none">
        <ul class="nav flex-column pb-3 mb-auto d-md-none">
            <li class="nav-item" data-bs-dismiss="offcanvas" data-bs-target="#sidebarMenu">
                <button type="button" class="nav-link d-flex align-items-center gap-2" [routerLink]="['/doctors/profile']">
                    <i class="bi bi-person"></i> Perfil
                </button>
            </li>
            <li class="nav-item" data-bs-dismiss="offcanvas" data-bs-target="#sidebarMenu">
                <button type="button" class="nav-link d-flex align-items-center gap-2" (click)="authService.logout()">
                    <i class="bi bi-power"></i> Sair
                </button>
            </li>
        </ul>
    </div>
</div>